export default __webpack_public_path__ + "static/media/bergen_festplassen2.9557a430.jpg";